import { formatDate, parseDateKey } from "../../utils/date";

// React Query keys
export const LEAVE_TYPES_KEY = "me:leaveTypes";
export const MY_LEAVE_BALANCES_KEY = "me:myLeaveBalances";
export const MY_LEAVE_REQUESTS_KEY = "me:myLeaveRequests";

// Leave statuses are lowercase in the API.
export const LEAVE_STATUS = {
  pending: { label: "Waiting for approval", tone: "amber" },
  approved: { label: "Approved", tone: "green" },
  rejected: { label: "Rejected", tone: "red" },
  cancelled: { label: "Cancelled", tone: "gray" },
};

export const STATUS_FILTER_TABS = [
  { id: "all", label: "All" },
  { id: "pending", label: "Pending" },
  { id: "approved", label: "Approved" },
  { id: "rejected", label: "Rejected" },
  { id: "cancelled", label: "Cancelled" },
];

// Leave can be filed ahead, so include next year.
export const getLeaveYearOptions = () => {
  const current = new Date().getFullYear();
  return [current + 1, current, current - 1, current - 2];
};

// "Oct 20 – Oct 22, 2026", or "Oct 20, 2026" for a single day.
export const formatDateRange = (start, end) => {
  if (start === end) return formatDate(start);

  const s = parseDateKey(start);
  const e = parseDateKey(end);
  const sameYear = s.getFullYear() === e.getFullYear();
  const startLabel = s.toLocaleDateString("en-PH", {
    month: "short",
    day: "numeric",
    ...(sameYear ? {} : { year: "numeric" }),
  });

  return `${startLabel} – ${formatDate(end)}`;
};

export const calendarDaysBetween = (start, end) => {
  const s = parseDateKey(start);
  const e = parseDateKey(end);
  if (!s || !e || e < s) return 0;
  return Math.round((e - s) / 86_400_000) + 1;
};

// Pending, or approved but not started yet (start date after today).
export const canCancelLeave = (request, todayKey) =>
  request.status === "pending" ||
  (request.status === "approved" && request.startDate > todayKey);

// First pending/approved request whose dates overlap [start, end].
// "YYYY-MM-DD" strings compare correctly as text.
export const findOverlappingLeave = (requests, start, end) =>
  requests.find(
    (r) =>
      (r.status === "pending" || r.status === "approved") &&
      r.startDate <= end &&
      start <= r.endDate,
  );
